import {
  AlertRule,
  CreateAlertRuleResponse,
  DeactivateAlertRuleResponse,
  ListAlertRulesResponse,
  UpdateAlertRuleResponse,
  ActivateAlertRuleResponse,
} from '@/api';
import { AlertRulesData } from '../models';

const listAlertRules = (response: ListAlertRulesResponse): AlertRulesData => ({
  items: response.data.items ?? [],
  total: response.data.total,
});

const getAlertRule = (response: CreateAlertRuleResponse): AlertRule =>
  response.data;

const updateAlertRule = (response: UpdateAlertRuleResponse): AlertRule =>
  response.data;

const activateAlertRule = (response: ActivateAlertRuleResponse): AlertRule =>
  response.data;

const deactivateAlertRule = (
  response: DeactivateAlertRuleResponse,
): AlertRule => response.data;

export {
  listAlertRules,
  getAlertRule,
  updateAlertRule,
  activateAlertRule,
  deactivateAlertRule,
};
